/**
 * Stripe Checkout cancel landing — when the agent clicks "back" or closes
 * the payment page. Friendly nudge back to /admin where the paywall
 * still shows the Subscribe button.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function BillingCancel() {
  return (
    <div data-testid="billing-cancel-page"
         style={{ minHeight: "100vh", background: "var(--surface)",
                  display: "flex", alignItems: "center", justifyContent: "center", padding: 32 }}>
      <div className="card" style={{ padding: "44px 48px", maxWidth: 520, width: "100%", textAlign: "center" }}>
        <span style={{
          width: 56, height: 56, borderRadius: 16, margin: "0 auto 22px",
          background: "var(--surface-alt)", color: "var(--text)",
          display: "inline-flex", alignItems: "center", justifyContent: "center",
        }}>
          <ArrowLeft size={26} />
        </span>
        <h1 className="font-serif" style={{ fontSize: 28, lineHeight: 1.2, margin: 0, marginBottom: 10, fontWeight: 500 }}>
          No charge made
        </h1>
        <p style={{ color: "var(--text-muted)", margin: 0, marginBottom: 22, lineHeight: 1.55 }}>
          You backed out before payment, so nothing was billed. Whenever you're ready,
          your portal will be waiting.
        </p>
        <Link to="/admin" className="btn-primary"
              data-testid="billing-cancel-back"
              style={{ textDecoration: "none", justifyContent: "center" }}>
          <Home size={14} /> Back to portal
        </Link>
      </div>
    </div>
  );
}
